import React, { useState, useEffect, useRef } from 'react';
import Scroller from 'ui-component/Scroller';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { FaSearch } from 'react-icons/fa';
import StatusBadge from 'ui-component/StatusBadge';
import { TbDatabaseExclamation } from 'react-icons/tb';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { IdentifyIcon, RepairsIcon } from 'ui-component/custom-icons/icons';
import RepairModal from '../modals/RepairModal';
import GradingModal from '../modals/GradingModal';
import { toast } from 'react-hot-toast';
import { Checkbox, Tooltip, Skeleton } from '@mui/material';
import ProductDetailModal from '../modals/ProductDetailModal';


// ✅ Clear
const QualityControlList = ({ operationDetails, handleReloadData, handleShowCheckboxAction, handleOpenGradingModal, handleCloseGradingModal, handleGetSelectedItems }) => {

    const topSection = useRef(null);
    const [gradingModalStatus, setGradingModalStatus] = useState(false);
    const [showRepairPopup, setShowRepairPopup] = useState(false);
    const [showDeleteRepairPopup, setShowDeleteShowRepairPopup] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [inboundList, setInboundList] = useState([]);
    const [productIndexRepair, setProductIndexRepair] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRepair, setSelectedRepair] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [allChecked, setAllChecked] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(true);

    useEffect(() => {
        updateInboundList();
        
    }, [operationDetails]);

    useEffect(() => {
        setGradingModalStatus(handleOpenGradingModal)
        
    }, [handleOpenGradingModal]);
    
    const updateInboundList = () => {

        // Construct a new summary details array from operationDetails.products
        const collection = operationDetails?.products?.map(product => ({
            id: product?.id,
            oldGradeId: product?.old_grade_id,
            oldGradeName: product?.old_grade_name,
            newGradeId: product?.new_grade_id,
            newGradeName: product?.new_grade_name,
            colorId: product?.color_id,
            colorName: product?.color_name,
            imei: product?.imei,
            productId: product?.product_id,
            productName: product?.product_name,
            quantity: product?.quantity,
            repairs: product?.repairs,
            isChecked: false,
            status: product?.status,
            comment: product?.comment,
            hasComment: product?.has_comment,
            showComment: false
        })) || [];
    
        // Update the summaryDetails state once with the new array
        setInboundList(collection);
		setTimeout(() => {
			setIsDataLoading(false);
		}, 1000);
    }


    const handleClose = () => {
        setShowRepairPopup(false);
        setShowDetails(false);
        handleCloseGradingModal(true)
    }
    const handleCloseDeleteRepair = () => {
        setShowDeleteShowRepairPopup(false)
    }

    const handleShowDetails = (item) => {
        setShowDetails(true);
        setSelectedItem(item);
    }

    const handleSearch = (value) => {
        if (value.length >= 3) {

            const filtered = inboundList.filter(item => 
                (item.imei && item.imei.includes(value)) || 
                (item.productName && item.productName.toLowerCase().includes(value.toLowerCase()))
            );
            setInboundList(filtered);
        } else {
            updateInboundList();
        }
    }

    const addRepair = (index, item) => {
        setShowRepairPopup(true);
        setProductIndexRepair(index)
        setSelectedItem(item);
    }

    const handleAddRepairs = (repairs) => {
        toast.promise(
            api
                .createOperationItemRepair(operationDetails?.id, {
                    operation_item_id: repairs?.operationItemId,
                    assigned_id: repairs?.assignedId,
                    cost: repairs?.repairCost,
                    currency: repairs?.repairCurrency,
                    repair_type_id: repairs?.repairTypeId,
                })
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData()
                        }

                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Adding repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to add repair</b>
            }
        );
    }
    
    const handleDeleteRepair = (index, repair, details) => {
        setShowDeleteShowRepairPopup(true);
        setSelectedRepair(repair);
        setSelectedProduct(details)
    }
    
    const deleteRepair = () => {
        toast.promise(
            api
                .deleteOperationItemRepair(selectedRepair?.id)
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData()
                            setShowDeleteShowRepairPopup(false)
                            setSelectedRepair(null)
                            setSelectedProduct(null)

                            const updatedRepairs = selectedProduct?.repairs.filter(
                                (r) => r.id !== selectedRepair?.id
                            );
                    
                            setSelectedItem((prevProduct) => ({
                                ...prevProduct,
                                repairs: updatedRepairs,
                            }));
                            // setSelectedItem(item);
                        }

                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Deleting repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to remove repair</b>
            }
        );
    }

    const handleCheckAllItems = () => {
        const newCheckedState = !allChecked;
        setAllChecked(newCheckedState);
        // setCheckedItems(checkedItems.map(item => ({ ...item, checked: newCheckedState })));
        const updatedInboundList = inboundList.map(item => ({ ...item, isChecked: newCheckedState }));
        setInboundList(updatedInboundList);
        handleGetSelectedItems(updatedInboundList.filter(item => item.isChecked));
    }

    const handleItemCheck = (index) => {
        // setHasCheckedItems
        const newList = [...inboundList];
        newList[index].isChecked = !newList[index].isChecked;
        setInboundList(newList);
        handleGetSelectedItems(newList.filter(item => item.isChecked));
    };


    const areAnyItemsChecked = () => {
        const bool = inboundList.some(item => item.isChecked);
        
        handleShowCheckboxAction(bool)
        return bool;
    };
    

    const handleProcessGrading = (items) => {
        toast.promise(
            api
                .setOperationItemGrade(operationDetails?.id, items)
                .then(
                    (res) => {
                        if (res.status) {
                            handleReloadData()
                            // handleClose();

                            handleCloseGradingModal(true)
                        }

                        return res?.status ? res : null;
                    },
                    () => { }
                ),
            {
                loading: 'Adding repair...',
                success: (data) => `${data.message}`,
                error: <b>Failed to add repair</b>
            }
        );
    }
    

    return (
        <>
            
            <div >
                <div className="bg-white pt-0">
                    <div className="d-flex align-items-center justify-content-between TableSerachBar" style={{ marginTop: '10px', marginBottom: '-10px' }}>
                        <div>
                            <h5 >Products</h5>
                        </div>
                        
                    </div>
                    <div className="d-flex align-items-center justify-content-between TableSerachBar">

                        <form className="form-inline navbar-search" style={{ position: 'absolute', right: '15px' }}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control bg-white border"
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon2"
                                    onChange={(e) => {
                                        handleSearch(e.target.value)
                                    }}
                                    style={{ width: '100%' }}
                                />
                                <span className="searchIcon">
                                    <FaSearch />
                                </span>
                            </div>
                        </form>
                    </div>

                    <Scroller extraHeight={topSection?.current?.clientHeight || 0}>
                        <table className="table pm-table">
                            <thead>
                                <tr>
                                    {
                                        operationDetails?.isCompleted !== 1 && (
                                            <PermissionAllowed permissions={['Operations Item Grading']}>
                                                <th scope="col" style={{ width: '30px' }}>
                                                    <Checkbox
                                                        style={{ padding: '5px', paddingLeft: 0 }}
                                                        onChange={() => {
                                                            handleCheckAllItems()
                                                        }}
                                                        // checked={false}
                                                        checked={inboundList.some(item => item.isChecked) ? true : false}
                                                    />
                                                </th>
                                            </PermissionAllowed>
                                        )
                                    }
                                    <th scope="col" style={{ width: '160px' }}>IMEI</th>
                                    <th scope="col">Product</th>
                                    <th scope="col" style={{ width: '140px' }}>Grade</th>
                                    <th scope="col" style={{ width: '100px' }}>Status</th>
                                    <th scope="col" style={{ width: '60px' }}>Repairs</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    (isDataLoading && inboundList.length < 1) ? (
                                        [...Array(25)].map((e, i) => (
                                            <tr>
                                                {[...Array(6)].map((e, i) => (
                                                    <td>
                                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        inboundList.length > 0 ? (
                                            inboundList?.map((item, index) => (
                                                <tr key={index} className="hover-row">
                                                    {
                                                        operationDetails?.isCompleted !== 1 && (
                                                            <PermissionAllowed permissions={['Operations Item Grading']}>
                                                                <td className="align-middle">
                                                                    
                                                                    <Checkbox
                                                                        style={{ padding: '5px', paddingLeft: 0 }}
                                                                        checked={item.isChecked || false}
                                                                        onChange={() => handleItemCheck(index)}
                                                                    />
                                                                </td>
                                                            </PermissionAllowed>
                                                        )
                                                    }
                                                    <td
                                                        className="align-middle cursor-pointer"
                                                        onClick={() => {
                                                            handleShowDetails(item)
                                                        }}
                                                    >
                                                        {
                                                            item.imei ? (
                                                                <span className="font500">{item?.imei}</span>
                                                            ) : (
                                                                <span className="font500 textGray">No IMEI</span>
                                                            )
                                                        }
                                                    </td>
                                                    <td
                                                        className="align-middle cursor-pointer"
                                                        onClick={() => {
                                                            handleShowDetails(item)
                                                        }}
                                                    >
                                                        <div>{item.productName}</div>
                                                        <div>
                                                            {
                                                                item.colorName ? (
                                                                    <span className="font500 textGray">{item?.colorName}</span>
                                                                ) : (
                                                                    <span className="font500 textGray">{item?.quantity} pcs</span>
                                                                )
                                                            }
                                                        </div>
                                                    </td>
                                                    <td
                                                        className="align-middle cursor-pointer"
                                                        onClick={() => {
                                                            handleShowDetails(item)
                                                        }}
                                                    >
                                                        {item?.oldGradeName}
                                                    </td>
                                                    
                                                    <td
                                                        className="align-middle cursor-pointer"
                                                        onClick={() => {
                                                            handleShowDetails(item)
                                                        }}
                                                    >
                                                        <StatusBadge itemStatus={item?.status} />
                                                    </td>
                                                    
                                                    <td
                                                        className="align-middle cursor-pointer"
                                                        onClick={() => {
                                                            handleShowDetails(item)
                                                        }}
                                                    >
                                                        { item?.repairs?.length }
                                                    </td>
                                                    <PermissionAllowed permissions={['Add Operations Repairs']}>
                                                        <td className="hover-button-container">
                                                            <div className="hover-button">
                                                                
                                                                <div
                                                                    className='btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer'
                                                                    onClick={() => addRepair(index, item)}
                                                                >
                                                                    <RepairsIcon height={'18px'} width={'18px'} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </PermissionAllowed>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={6}>
                                                    <div className="not-found-container cstm-not-found" style={{ height: '385px' }}>
                                                        <div className="not-found-icon">
                                                            <TbDatabaseExclamation />
                                                        </div>
                                                        <h6 className="not-found-text">No Products Inbounded</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    )
                                }
                            </tbody>
                        </table>

                    </Scroller>
                    <PermissionAllowed permissions={['Operations Item Grading']}>
                        <div className="row d-none" style={{ marginBottom: '10px' }}>
                            <div className="col-1">
                                <div className="d-flex justify-content-start">
                                    <Tooltip title={'Identify Grading'} arrow placement="top">
                                        <button
                                            style={{ marginBottom: '-5px' }}
                                            className="btn btn-primary btn-outlined-main white-var btn-icon-only btn-icon-square"
                                            
                                            disabled={!areAnyItemsChecked()}
                                        >
                                            <IdentifyIcon width={'16px'} height={'16px'} />
                                        </button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </PermissionAllowed>
                </div>
            </div>


            {showRepairPopup && (
                <RepairModal
                    openPopup={showRepairPopup}
                    selectedItem={selectedItem}
                    index={productIndexRepair}
                    handleClose={handleClose}
                    handleAddRepairs={handleAddRepairs}
                />
            )}
            {gradingModalStatus && (
                <GradingModal
                    openPopup={gradingModalStatus}
                    details={inboundList}
                    handleClose={handleClose}
                    handleProcessGrading={handleProcessGrading}
                />
            )}
            {showDetails && (
                <ProductDetailModal
                    openPopup={showDetails}
                    details={selectedItem}
                    handleClose={handleClose}
                    handleDeleteRepair={handleDeleteRepair}
                />
            )}
			{showDeleteRepairPopup && (
				<DeleteConfirmation
					show={showDeleteRepairPopup}
					handleClose={handleCloseDeleteRepair}
					handleDelete={deleteRepair}
					title="Confirm"
					message={`Are you sure you want to delete ${selectedRepair?.repair_type?.name} from the repair list?`}
				/>
			)}

        </>
    );
};

export default QualityControlList;
